import type {ReactElement} from 'react';
import {useCallback, useState} from 'react';
import {HumanInputType, RejectionBehavior} from '@Components/ai-chat-window/ai-chat-window.types';
import {getUniqueString} from '@Utils/string.util';
import type {HumanInputButtonsInteractionProps} from './human-input-buttons.types';
import styles from './human-input-buttons.module.scss';
import {Button, Size, Type} from "@Components/button";

export function HumanInputButtons({chatId, resumeToken, inputType, rejectionBehavior, onResumeWorkflow}: HumanInputButtonsInteractionProps): ReactElement {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const isDisabled = isSubmitting || submitted;

  const rejectLabel = rejectionBehavior === RejectionBehavior.CONTINUE ? window.i18next.t('pmwjs_skip') : window.i18next.t('pmwjs_reject');

  const handleResponse = useCallback(
    async (response: boolean): Promise<void> => {
      if (!onResumeWorkflow || submitted) {
        return;
      }

      setIsSubmitting(true);
      setSubmitted(true);

      const rejectEchoKey = rejectionBehavior === RejectionBehavior.CONTINUE ? 'pmwjs_skipped' : 'pmwjs_rejected';
      const userEchoText = response ? window.i18next.t('pmwjs_approved') : window.i18next.t(rejectEchoKey);

      await onResumeWorkflow(
        chatId,
        {
          chatId,
          resumeToken,
          inputType,
          response,
          messageSessionUid: getUniqueString(),
        },
        userEchoText
      );

      setIsSubmitting(false);
    },
    [chatId, resumeToken, inputType, rejectionBehavior, onResumeWorkflow, submitted]
  );

  if (inputType !== HumanInputType.BOOLEAN) {
    return <></>;
  }


  return (
    <div className={styles.actions}>
      <Button size={Size.SMALL} type={Type.PRIMARY} text={window.i18next.t('pmwjs_approve')} onClick={(): void => void handleResponse(true)} disabled={isDisabled} />
      <Button size={Size.SMALL} type={Type.SECONDARY} text={rejectLabel} onClick={(): void => void handleResponse(false)} disabled={isDisabled} />
    </div>
  );
}
